<!--<button type="button" (click)="onSearch()"></button>
<input #input type="search" [placeholder]="placeholder">-->
<!-- Buscador -->

<button class="bg-transparent text-gray-400 pr-2 flex-shrink-0 -mr-8" type="button" (click)="onSearch()">
    <svg [tooltip]="'words.search' | translate"  fill="none" stroke="currentColor" viewBox="0 0 24 24" class="text-gray-500  w-4 h-4"><path  stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
  <!--  <i [tooltip]="'words.search' | translate" class="fa-solid fa-magnifying-glass text-gray-400"></i>-->
</button>
<input #input type="search" [placeholder]="placeholder ? (placeholder | translate) : ('words.search-for-coursess' | translate)" class="        
         placeholder:text-gray-500 text-gray-500 rounded-full placeholder:font-light placeholder:text-sm w-full p-2 pl-8 focus:outline-none font-[400] text-sm" />
